const advantages = [
  { icon: 'ri-search-line', title: 'Диагностика', desc: 'Перед стартом — глубокий аудит компетенций, KPI и бизнес-процессов. Программа строится на реальных данных, а не на предположениях.' },
  { icon: 'ri-tools-line', title: '80% практики', desc: 'Минимум теории, максимум отработки. Кейсы из реального бизнеса, ролевые игры, проектная работа. Навыки формируются через действие.' },
  { icon: 'ri-file-list-3-line', title: 'Реальные кейсы', desc: '100+ корпоративных проектов в разных отраслях. Опыт, который можно применить к вашему бизнесу, а не абстрактные примеры из учебников.' },
  { icon: 'ri-settings-3-line', title: 'Адаптация программы', desc: 'Каждая программа создаётся под конкретную компанию: отрасль, размер, уровень сотрудников, бизнес-цели. Никаких типовых решений.' },
  { icon: 'ri-user-heart-line', title: 'Посттренинговое сопровождение', desc: 'Обучение не заканчивается в последний день тренинга. План сопровождения на 3 месяца: чек-поинты, обратная связь, закрепление навыков.' },
  { icon: 'ri-bar-chart-grouped-line', title: 'Измерение результата', desc: 'Оценка эффективности по бизнес-показателям: конверсия, средний чек, NPS, текучесть. Отчёт для руководителя с конкретными цифрами.' },
  { icon: 'ri-award-line', title: '18+ лет опыта', desc: 'Более 18 лет в корпоративном обучении. Сотни успешных проектов в Беларуси, России, Казахстане и Израиле.' },
  { icon: 'ri-building-2-line', title: '100+ проектов', desc: 'Опыт работы с компаниями от 20 до 1000+ сотрудников в производстве, IT, ритейле, услугах и других отраслях.' },
];

export default function WhyBusinessTraining() {
  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Почему BusinessTraining.by
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Системный подход, измеримые результаты и глубокая экспертиза — то, что отличает нашу работу от «просто тренингов»
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {advantages.map((a, i) => (
            <div key={i} className="bg-white rounded-2xl p-6 border border-gray-100 hover:border-teal-200 hover:shadow-md transition-all group">
              <div className="w-12 h-12 bg-teal-600 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <i className={`${a.icon} text-xl text-white`}></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-2">{a.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{a.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}